import React from 'react';
import { Link } from 'react-router-dom';
import { FileImage, BookOpen, MapPin, FileText } from 'lucide-react';

const sections = [
  { title: 'Media Library', desc: 'Upload and manage images, PDFs, and documents', icon: FileImage, path: '/advisor/content/media', testId: 'content-hub-media' },
  { title: 'Journal', desc: 'Create and publish editorial travel stories', icon: BookOpen, path: '/advisor/content/journal', testId: 'content-hub-journal' },
  { title: 'Destinations', desc: 'Manage destination pages and regional content', icon: MapPin, path: '/advisor/content/destinations', testId: 'content-hub-destinations' },
  { title: 'Travel Guides', desc: 'Upload and manage downloadable travel guides', icon: FileText, path: '/advisor/content/guides', testId: 'content-hub-guides' },
];

export default function ContentHub() {
  return (
    <div className="min-h-screen bg-[#FAFAF8]" data-testid="content-hub">
      <div className="max-w-4xl mx-auto px-6 py-16">
        <div className="mb-12">
          <Link to="/advisor" className="text-xs uppercase tracking-[0.15em] text-[#999] hover:text-[#1A1A1A] transition-colors">
            Dashboard
          </Link>
          <h1 className="font-serif text-3xl text-[#1A1A1A] mt-4">Content</h1>
          <p className="text-sm text-[#6B6B6B] mt-2">Manage editorial content, media, and destination pages.</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
          {sections.map(({ title, desc, icon: Icon, path, testId }) => (
            <Link
              key={path}
              to={path}
              className="group block p-8 bg-white border border-[#E8E4DC] rounded-lg hover:border-[#1A1A1A] transition-colors"
              data-testid={testId}
            >
              <Icon size={20} className="text-[#999] group-hover:text-[#1A1A1A] transition-colors mb-4" strokeWidth={1.5} />
              <h2 className="font-serif text-lg text-[#1A1A1A] mb-1">{title}</h2>
              <p className="text-sm text-[#6B6B6B]">{desc}</p>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}
